import React, { useEffect, useState } from "react";
import { Image, Skeleton } from "antd";
import "antd/dist/reset.css";
import { BASE_URL } from "../constants/Url";
import { useTranslation } from "react-i18next";
import BackHome from "../components/BackHome";

const AboutPage = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);

    // ⏳ setTimeout 1 minute (1000ms) to switch loading -> data
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false); // 🔥 stop loading after 1min
        }, 1000);

        return () => clearTimeout(timer); // Cleanup if unmount
    }, []);
    return (
        <div style={{ padding: "0px" }}>
            <BackHome title={t("About")} t={t}/>
            <div className='esi-white-space'></div>
            {/* About School Section */}
            <div className='esi-std-container'>
                {
                    loading ?
                        <div className="grid grid-cols-7 cursor-pointer select-none" style={{ marginBottom: "3rem" }}>
                            <div className='col-span-4 px-3 flex flex-col justify-between'>
                                <div className='flex flex-col gap-1'>
                                    <Skeleton.Input className="esi-news-card-title max-w-[50%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input
                                        rootClassName='max-sm:!hidden md:!block'
                                        className="esi-news-card-description max-w-[100%] line-clamp-2 sm:line-clamp-3" active block />
                                </div>
                            </div>
                            <div className="col-span-3 overflow-hidden rounded-[0.5rem]">
                                <Skeleton.Image rootClassName='esi-sub-news-card-image' style={{ cursor: "pointer" }} className='esi-sub-news-card-image' active={true} />
                            </div>
                        </div> :
                        <div className='md:grid grid-cols-5 gap-3 flex flex-col-reverse'>
                            <div className='max-w-[640px] pt-5 pb-5 sm:pb-10 col-span-3 flex flex-col gap-3'>
                                <div className='esi-content-title'>
                                    {t("History and Present")}
                                    <div className='esi-secondary-line'></div>
                                </div>
                                {/* <div className='esi-content-title mt-6'>
                                {t("School Management System")}
                            </div> */}
                                <div className='flex flex-col gap-4 mt-3'>
                                    <div className='esi-content' style={{ lineHeight: 2 }}>{t("Sreymoeun Soeung Khmer is a social enterprise found in June 01, 2018.")}</div>
                                </div>
                            </div>
                            <div className='col-span-2'>
                                <Image src={BASE_URL + "/about-us/Present.jpg"} className='esi-image' alt='School' />
                            </div>
                        </div>
                }
            </div>
            <div className='esi-std-container'>
                {
                    loading ?
                        <div className="grid grid-cols-7 cursor-pointer select-none" style={{ marginBottom: "3rem" }}>
                            <div className="col-span-3 overflow-hidden rounded-[0.5rem]">
                                <Skeleton.Image rootClassName='esi-sub-news-card-image' style={{ cursor: "pointer" }} className='esi-sub-news-card-image' active={true} />
                            </div>
                            <div className='col-span-4 px-3 flex flex-col justify-between'>
                                <div className='flex flex-col gap-1'>
                                    <Skeleton.Input className="esi-news-card-title max-w-[50%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input
                                        rootClassName='max-sm:!hidden md:!block'
                                        className="esi-news-card-description max-w-[100%] line-clamp-2 sm:line-clamp-3" active block />
                                </div>
                            </div>
                        </div> :
                        <div className='md:grid grid-cols-5 gap-3 flex flex-col-reverse'>
                            <div className='col-span-2 gap-4'>
                                <Image src={BASE_URL + "/about-us/About1.jpg"} className='esi-image' alt='School' />
                            </div>
                            <div className='max-w-[800px] pt-5 pb-5 sm:pb-10 col-span-3 flex flex-col gap-3' style={{ marginLeft: "5rem" }}>
                                <div className='esi-content-title'>
                                    {t("Missions")}
                                    <div className='esi-secondary-line'></div>
                                </div>
                                <div className='flex flex-col gap-4 mt-3'>
                                    <div className='esi-content' style={{ lineHeight: 2 }}>
                                        <ul>
                                            <li>{t("Improve the products of Silk, Cotton Fabric toward customer’s needs and satisfaction.")}</li>
                                        </ul>

                                        <h4 className="text-success fw-bold mt-4" style={{ color: "#119811", fontSize: "1.5rem", fontWeight: 600 }}>Sreymoeun Soeung Khmer’s core Values</h4>
                                        <ul>
                                            <li><strong>1. Leadership:</strong> The commitment to be better than now</li>
                                            <li><strong>2. Collaboration:</strong> Join us, We grow.</li>
                                            <li><strong>3. Integrity:</strong> Be true</li>
                                            <li><strong>4. Accountability:</strong> Keep our credit alive.</li>
                                            <li><strong>5. Passion:</strong> Work from heart and Mind and Believe to grow.</li>
                                            <li><strong>6. Diversity:</strong> Traditional Modern Inclusion.</li>
                                            <li><strong>7. Quality:</strong> Satisfaction Bring Affection. What we do, we do well.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </div>
            <div className='esi-std-container'>
                {
                    loading ?
                        <div className="grid grid-cols-7 cursor-pointer select-none" style={{ marginBottom: "3rem" }}>
                            <div className='col-span-4 px-3 flex flex-col justify-between'>
                                <div className='flex flex-col gap-1'>
                                    <Skeleton.Input className="esi-news-card-title max-w-[50%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input
                                        rootClassName='max-sm:!hidden md:!block'
                                        className="esi-news-card-description max-w-[100%] line-clamp-2 sm:line-clamp-3" active block />
                                </div>
                            </div>
                            <div className="col-span-3 overflow-hidden rounded-[0.5rem]">
                                <Skeleton.Image rootClassName='esi-sub-news-card-image' style={{ cursor: "pointer" }} className='esi-sub-news-card-image' active={true} />
                            </div>
                        </div> :
                        <div className='md:grid grid-cols-5 gap-3 flex flex-col-reverse'>
                            <div className='max-w-[640px] pt-5 pb-5 sm:pb-10 col-span-3 flex flex-col gap-3'>
                                <div className='esi-content-title'>
                                    {t("Target Objectives")}
                                    <div className='esi-secondary-line'></div>
                                </div>
                                {/* <div className='esi-content-title mt-6'>
                            {t("School Management System")}
                        </div> */}
                                <div className='flex flex-col gap-4 mt-3'>
                                    <div className='esi-content' style={{ lineHeight: 2 }}>
                                        <ul>
                                            <li><strong>1.</strong>To Promote all types of Soeung, Phamoung, Hole, Scarves and handmade fabric to have been used nationwide and international.</li>
                                            <li><strong>2.</strong> To eradicate women weavers’ immigration in community.</li>
                                            <li><strong>3.</strong> To promote social economic status for women in the families.                                    </li>
                                            <li><strong>4.</strong> To reduce domestic violence in the family.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-span-2'>
                                <Image src={BASE_URL + "/about-us/About2.jpg"} className='esi-image' alt='School' />
                            </div>
                        </div>
                }
            </div>

            <div className='esi-std-container'>
                {
                    loading ?
                        <div className="grid grid-cols-7 cursor-pointer select-none" style={{ marginBottom: "3rem" }}>
                            <div className="col-span-3 overflow-hidden rounded-[0.5rem]">
                                <Skeleton.Image rootClassName='esi-sub-news-card-image' style={{ cursor: "pointer" }} className='esi-sub-news-card-image' active={true} />
                            </div>
                            <div className='col-span-4 px-3 flex flex-col justify-between'>
                                <div className='flex flex-col gap-1'>
                                    <Skeleton.Input className="esi-news-card-title max-w-[50%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                    <Skeleton.Input
                                        rootClassName='max-sm:!hidden md:!block'
                                        className="esi-news-card-description max-w-[100%] line-clamp-2 sm:line-clamp-3" active block />
                                </div>
                            </div>
                        </div> :
                        <div className='md:grid grid-cols-5 gap-3 flex flex-col-reverse'>
                            <div className='col-span-2'>
                                <Image src={BASE_URL + "/about-us/About.jpg"} className='esi-image' alt='School' />
                            </div>
                            <div className='max-w-[640px] pt-5 pb-5 sm:pb-10 col-span-3 flex flex-col gap-3' style={{ marginLeft: "5rem" }}>
                                <div className='esi-content-title'>
                                    {t("Vision")}
                                    <div className='esi-secondary-line'></div>
                                </div>
                                <div className='flex flex-col gap-4 mt-3'>
                                    <div className='esi-content' style={{ lineHeight: 2 }}>
                                        <ul>
                                            <li><strong>1.</strong> Production with good quality, beauty and confident through Sreymoeun Soeung Khmer toward the progress and society satisfaction.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </div>
            <div className='esi-white-space'></div>
        </div>
    );
};

export default AboutPage;




